var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9925 8.05543C17.623 7.6659 17.0071 7.64874 16.617 8.0191L10.4056 13.9098L7.44287 10.868C7.06763 10.483 6.4524 10.4746 6.06709 10.8498C5.6821 11.2247 5.67399 11.8406 6.0489 12.2256L9.68134 15.955C9.8717 16.1506 10.1247 16.2492 10.3783 16.2492C10.619 16.2492 10.8596 16.1603 11.0481 15.9823L17.9562 9.43093C18.346 9.06118 18.3625 8.44529 17.9925 8.05543Z",
    fill: "#91B848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38312 0 0 5.38312 0 12C0 18.6169 5.38312 24 12 24C18.6169 24 24 18.6169 24 12C24 5.38312 18.6169 0 12 0ZM12 22.0541C6.45633 22.0541 1.94592 17.544 1.94592 12C1.94592 6.45633 6.45628 1.94592 12 1.94592C17.544 1.94592 22.0541 6.45628 22.0541 12C22.0541 17.544 17.544 22.0541 12 22.0541Z",
    fill: "#91B848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notification-success.e79ad795b1c97e4a651b90fe1df30452.svg";
export { ForwardRef as ReactComponent };